export function ensureNcinoWebComponents () {
  // Check if any ncino components are already registered
  const isRegistered = customElements.get('ngc-skeleton-loader') !== undefined

  if (!isRegistered) {
    require('@ncino/web-components')
  }
}
